import React from 'react';
import { EmptyState, Button } from '@chatsdet/ui';
import { Sparkle } from '@phosphor-icons/react';
import { useAssistant } from './AssistantContext';

type LegacyChatTombstoneProps = {
  title: string;
  description: string;
  className: string;
};

/** Keeps a retired chat location discoverable while directing users to the global Assistant. */
export function LegacyChatTombstone({ title, description, className }: LegacyChatTombstoneProps) {
  const { openAssistant } = useAssistant();

  return (
    <EmptyState
      size="md"
      className={className}
      title={title}
      description={description}
      action={
        <Button
          size="sm"
          variant="primary"
          iconLeft={<Sparkle size={16} weight="fill" />}
          onPress={() => openAssistant()}
        >
          Open Assistant
        </Button>
      }
    />
  );
}
